import React from 'react'
import { Button } from 'primereact/button'
import { Toolbar } from 'primereact/toolbar'
import { ScrollTop } from 'primereact/scrolltop'
import { Card, CardBody, Col, Row } from 'reactstrap'
import { Tooltip } from 'primereact/tooltip'

const MainContentLayout = (props) => {
  const pageTitle = props.title || 'Origins Direct'
  document.title = props.title ? `${pageTitle} | Origins Direct` : 'Origins Direct'

  const exportCSV = () => {
    if (props.handleExport) {
      props.dt()
    } else {
      props.dt.current.exportCSV()
    }
  }

  const exportZip = () => {
    if (props.handleExportZip) {
      props.dtZip()
    }
  }

  // const exportCSV = () => props.dt.current.exportCSV()

  const rightToolbarTemplate = () => (
    <div className='d-flex gap-2'>
      <Button
        label='Export CSV'
        loading={props.loading}
        icon='pi pi-upload'
        className='p-button-help'
        onClick={exportCSV}
      />
      {props.dtZip && (
        <Button
          label='Export ZIP'
          loading={props.zipLoading}
          icon='pi pi-download'
          className='p-button-help'
          onClick={exportZip}
        />
      )}
    </div>
  )

  return (
    <React.Fragment>
      <div className='page-content'>
        <div className='container-fluid'>
          <h2 className='fs-3 fw-bold mt-4 mb-4'>{pageTitle}</h2>

          <Row>
            <Col className='col-12'>
              <Card>
                <CardBody>
                  {props.children}
                  {(props.dt || props.bottomToolbarLeft) && (
                    <Toolbar
                      className='mt-2'
                      left={props.bottomToolbarLeft}
                      right={props.dt ? rightToolbarTemplate : undefined}
                    />
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
          <ScrollTop />
        </div>
      </div>
      <Tooltip target='.p-sortable-column-icon' content='Sort' />
      <Tooltip target='.p-column-filter-menu-button' content='Filter' />
    </React.Fragment>
  )
}

export default MainContentLayout
